"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOtherHomeItemIds = exports["default"] = void 0;
exports.getPricingVersion = getPricingVersion;
// i18next-extract-mark-ns-start Trees
function getPricingVersion() {
  return 13;
}
var getTree = function getTree(t) {
  var pricingVersion = getPricingVersion();
  return [{
    name: t('Pantalon'),
    slug: 'pant',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'tooLargeLeg',
          label: t('Sur les jambes'),
          id: "".concat(pricingVersion, ".pant-ret-cin-2")
        }, {
          slug: 'tooLargeCrotch',
          label: t('À l’entrejambe'),
          id: "".concat(pricingVersion, ".pant-ret-cin-4")
        }, {
          slug: 'tooLargeBelt',
          label: t('À la ceinture'),
          id: "".concat(pricingVersion, ".pant-ret-cin-1")
        }, {
          slug: 'tooLargeLength',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".pant-ret-rac-1")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'tooSmallLeg',
          label: t('Sur les jambes'),
          id: "".concat(pricingVersion, ".pant-ret-ela-2")
        }, {
          slug: 'tooSmallCrotch',
          label: t('À l’entrejambe'),
          id: "".concat(pricingVersion, ".pant-ret-ela-4")
        }, {
          slug: 'tooSmallBelt',
          label: t('À la ceinture'),
          id: "".concat(pricingVersion, ".pant-ret-ela-1")
        }, {
          slug: 'tooSmallLength',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".pant-ret-ral-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".pant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pant-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }]
      }, {
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".pant-ret-rac-1")
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".pant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pant-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'unraveledHem2',
          label: t('L‘ourlet est décousu (x2 jambes)'),
          id: "".concat(pricingVersion, ".pant-rep-div-7")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Manteau & veste'),
    slug: 'mant',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".mant-ret-rac-2")
        }, {
          slug: 'tooLong',
          label: t('Il est trop long'),
          id: "".concat(pricingVersion, ".mant-ret-rac-1")
        }, {
          slug: 'largeChest',
          label: t('Buste trop large'),
          id: "".concat(pricingVersion, ".mant-ret-cin-4")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".mant-ret-cin-2")
        }, {
          slug: 'largeShoulder',
          label: t('Épaules trop larges'),
          id: "".concat(pricingVersion, ".mant-ret-cin-1")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".mant-ret-ral-2")
        }, {
          slug: 'shortChest',
          label: t('Buste trop étroit'),
          id: "".concat(pricingVersion, ".mant-ret-ela-4")
        }, {
          slug: 'tooShort',
          label: t('Il est trop court'),
          id: "".concat(pricingVersion, ".mant-ret-ral-1")
        }, {
          slug: 'armTooTight',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".mant-ret-ela-2")
        }, {
          slug: 'shoulderTooTight',
          label: t('Épaules trop serrées'),
          id: "".concat(pricingVersion, ".mant-ret-ela-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'entireLining',
          label: t('Sur toute la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-3")
        }, {
          slug: 'liningPart',
          label: t('Sur une partie de la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-2")
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".mant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mant-rep-zip-3"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".mant-rep-tear-2"),
          multiple: true
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'entireLining',
          label: t('Sur toute la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-3")
        }, {
          slug: 'liningPart',
          label: t('Sur une partie de la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-2")
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".mant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mant-rep-zip-3"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".mant-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Robe'),
    slug: 'robe',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Elle est trop grande'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLarge',
          label: t('Elle est trop large'),
          id: "".concat(pricingVersion, ".robe-ret-cin-1")
        }, {
          slug: 'tooLong',
          label: t('Elle est trop longue'),
          id: "".concat(pricingVersion, ".robe-ret-rac-1")
        }, {
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".robe-ret-rac-4")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".robe-ret-cin-3")
        }, {
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".robe-ret-rac-6")
        }, {
          slug: 'largeShoulder',
          label: t('Épaules trop large'),
          id: "".concat(pricingVersion, ".robe-ret-cin-2")
        }, {
          slug: 'largeChest',
          label: t('Buste trop large'),
          id: "".concat(pricingVersion, ".robe-ret-cin-5")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Elle est trop petite'),
        question: t('À quel endroit est-elle trop petite ?'),
        locations: [{
          slug: 'tooShort',
          label: t('Elle est trop courte'),
          id: "".concat(pricingVersion, ".robe-ret-ral-1")
        }, {
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".robe-ret-ral-4")
        }, {
          slug: 'armTooTight',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".robe-ret-ela-3")
        }, {
          slug: 'tooSmallSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".robe-ret-ral-6")
        }, {
          slug: 'smallShoulder',
          label: t('Épaules trop étroite'),
          id: "".concat(pricingVersion, ".robe-ret-ela-2")
        }, {
          slug: 'smallChest',
          label: t('Buste trop étroit'),
          id: "".concat(pricingVersion, ".robe-ret-ela-5")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".robe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".robe-rep-zip-5"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".robe-rep-tear-1"),
          multiple: true
        }]
      }, {
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".robe-ret-rac-1")
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".robe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".robe-rep-zip-5"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".robe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'unraveledHem',
          label: t('L‘ourlet est décousu'),
          id: "".concat(pricingVersion, ".robe-rep-div-6")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Haut'),
    slug: 'haut',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".haut-ret-rac-2")
        }, {
          slug: 'tooLong',
          label: t('Il est trop long'),
          id: "".concat(pricingVersion, ".haut-ret-rac-1")
        }, {
          slug: 'largeChest',
          label: t('Buste trop large'),
          id: "".concat(pricingVersion, ".haut-ret-cin-4")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".haut-ret-cin-2")
        }, {
          slug: 'largeShoulder',
          label: t('Épaules trop larges'),
          id: "".concat(pricingVersion, ".haut-ret-cin-1")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".haut-ret-ral-2")
        }, {
          slug: 'shortChest',
          label: t('Buste trop étroit'),
          id: "".concat(pricingVersion, ".haut-ret-ela-4")
        }, {
          slug: 'tooShort',
          label: t('Il est trop court'),
          id: "".concat(pricingVersion, ".haut-ret-ral-1")
        }, {
          slug: 'armTooTight',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".haut-ret-ela-2")
        }, {
          slug: 'shoulderTooTight',
          label: t('Épaules trop serrées'),
          id: "".concat(pricingVersion, ".haut-ret-ela-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".haut-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".haut-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".haut-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".haut-rep-tear-2"),
          multiple: true
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".haut-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".haut-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".haut-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".haut-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Jupe'),
    slug: 'jupe',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Elle est trop grande'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLarge',
          label: t('Elle est trop large'),
          id: "".concat(pricingVersion, ".jupe-ret-cin-1")
        }, {
          slug: 'tooLong',
          label: t('Elle est trop longue'),
          id: "".concat(pricingVersion, ".jupe-ret-rac-1")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Elle est trop petite'),
        question: t('À quel endroit est-elle trop petite ?'),
        locations: [{
          slug: 'tooSmall',
          label: t('Elle est trop étroite'),
          id: "".concat(pricingVersion, ".jupe-ret-ela-1")
        }, {
          slug: 'tooShort',
          label: t('Elle est trop courte'),
          id: "".concat(pricingVersion, ".jupe-ret-ral-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".jupe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".jupe-rep-zip-4"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Elle nécessite un renfort'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-2"),
          multiple: true
        }]
      }, {
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".jupe-ret-rac-1")
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".jupe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".jupe-rep-zip-4"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Elle nécessite un renfort'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-2"),
          multiple: true
        }, {
          slug: 'unraveledHem',
          label: t('L‘ourlet est décousu'),
          id: "".concat(pricingVersion, ".jupe-rep-div-6")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Pull & gilet'),
    slug: 'pull',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".pull-ret-rac-2")
        }, {
          slug: 'tooLong',
          label: t('Il est trop long'),
          id: "".concat(pricingVersion, ".pull-ret-rac-1")
        }, {
          slug: 'largeChest',
          label: t('Buste trop large'),
          id: "".concat(pricingVersion, ".pull-ret-cin-5")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".pull-ret-cin-3")
        }, {
          slug: 'largeShoulder',
          label: t('Épaules trop larges'),
          id: "".concat(pricingVersion, ".pull-ret-cin-2")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".pull-ret-ral-2")
        }, {
          slug: 'shortChest',
          label: t('Buste trop étroit'),
          id: "".concat(pricingVersion, ".pull-ret-ela-5")
        }, {
          slug: 'tooShort',
          label: t('Il est trop court'),
          id: "".concat(pricingVersion, ".pull-ret-ral-1")
        }, {
          slug: 'armTooTight',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".pull-ret-ela-3")
        }, {
          slug: 'shoulderTooTight',
          label: t('Épaules trop serrées'),
          id: "".concat(pricingVersion, ".pull-ret-ela-2")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pull-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pull-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pull-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".pull-rep-tear-2"),
          multiple: true
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pull-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pull-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pull-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".pull-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Lingerie'),
    slug: 'ling',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-rac-1")
        }, {
          slug: 'chest',
          label: t('Au niveau de la poitrine'),
          id: "".concat(pricingVersion, ".ling-ret-cin-1")
        }, {
          slug: 'tooLarge',
          label: t('Au niveau de la taille'),
          id: "".concat(pricingVersion, ".ling-ret-cin-3")
        }, {
          slug: 'tooLong',
          label: t('Il est trop long'),
          id: "".concat(pricingVersion, ".ling-ret-rac-3")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'tooSmallSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-ral-1")
        }, {
          slug: 'chest',
          label: t('Au niveau de la poitrine'),
          id: "".concat(pricingVersion, ".ling-ret-ela-1")
        }, {
          slug: 'tooSmall',
          label: t('Au niveau de la taille'),
          id: "".concat(pricingVersion, ".ling-ret-ela-2")
        }, {
          slug: 'tooShort',
          label: t('Il est trop court'),
          id: "".concat(pricingVersion, ".ling-ret-ral-3")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Combinaison'),
    slug: 'comb',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Elle est trop grande'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".comb-ret-rac-1")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".comb-ret-cin-2")
        }, {
          slug: 'largeChest',
          label: t('Buste / Taille trop large'),
          id: "".concat(pricingVersion, ".comb-ret-cin-3")
        }, {
          slug: 'largeCrotch',
          label: t('À l’entrejambe'),
          id: "".concat(pricingVersion, ".comb-ret-cin-8")
        }, {
          slug: 'largeLeg',
          label: t('Jambes trop larges'),
          id: "".concat(pricingVersion, ".comb-ret-cin-6")
        }, {
          slug: 'longLeg',
          label: t('Jambes trop longues'),
          id: "".concat(pricingVersion, ".comb-ret-rac-3")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Elle est trop petite'),
        question: t('À quel endroit est-elle trop petite ?'),
        locations: [{
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".comb-ret-ral-1")
        }, {
          slug: 'tightArm',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".comb-ret-ela-2")
        }, {
          slug: 'tightChest',
          label: t('Buste / Taille trop serrée'),
          id: "".concat(pricingVersion, ".comb-ret-ela-3")
        }, {
          slug: 'smallCrotch',
          label: t('À l’entrejambe'),
          id: "".concat(pricingVersion, ".comb-ret-ela-8")
        }, {
          slug: 'tightLeg',
          label: t('Jambes trop serrées'),
          id: "".concat(pricingVersion, ".comb-ret-ela-6")
        }, {
          slug: 'shortLeg',
          label: t('Jambes trop courtes'),
          id: "".concat(pricingVersion, ".comb-ret-ral-3")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".comb-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".comb-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".comb-rep-tear-3")
        }]
      }, {
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".comb-ret-rac-3")
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".comb-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".comb-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".comb-rep-tear-3")
        }, {
          slug: 'unraveledHem2',
          label: t('L‘ourlet est décousu (x2 jambes)'),
          id: "".concat(pricingVersion, ".comb-rep-div-5")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Maillot de bain'),
    slug: 'mail',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Il est trop grand'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-rac-1")
        }, {
          slug: 'chest',
          label: t('Au niveau de la poitrine'),
          id: "".concat(pricingVersion, ".ling-ret-cin-1")
        }, {
          slug: 'tooLarge',
          label: t('Au niveau de la taille'),
          id: "".concat(pricingVersion, ".ling-ret-cin-3")
        }, {
          slug: 'tooLong',
          label: t('Il est trop long'),
          id: "".concat(pricingVersion, ".ling-ret-rac-3")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Il est trop petit'),
        question: t('À quel endroit est-il trop petit ?'),
        locations: [{
          slug: 'tooSmallSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-ral-1")
        }, {
          slug: 'chest',
          label: t('Au niveau de la poitrine'),
          id: "".concat(pricingVersion, ".ling-ret-ela-1")
        }, {
          slug: 'tooSmall',
          label: t('Au niveau de la taille'),
          id: "".concat(pricingVersion, ".ling-ret-ela-2")
        }, {
          slug: 'tooShort',
          label: t('Il est trop court'),
          id: "".concat(pricingVersion, ".ling-ret-ral-3")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Costume'),
    slug: 'cost',
    pieces: {
      mant: {
        name: t('Veste de costume')
      },
      pant: {
        name: t('Pantalon de costume')
      }
    },
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Robe de mariée'),
    slug: 'mari',
    hasNoTypes: true,
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLarge',
        label: t('Elle est trop grande'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLarge',
          label: t('Elle est trop large'),
          id: "".concat(pricingVersion, ".mari-ret-cin-1")
        }, {
          slug: 'tooLong',
          label: t('Elle est trop longue'),
          id: "".concat(pricingVersion, ".mari-ret-rac-1")
        }, {
          slug: 'longArm',
          label: t('Manches trop longues'),
          id: "".concat(pricingVersion, ".mari-ret-rac-4")
        }, {
          slug: 'largeArm',
          label: t('Manches trop larges'),
          id: "".concat(pricingVersion, ".mari-ret-cin-3")
        }, {
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".mari-ret-rac-6")
        }, {
          slug: 'largeShoulder',
          label: t('Épaules trop large'),
          id: "".concat(pricingVersion, ".mari-ret-cin-2")
        }, {
          slug: 'largeChest',
          label: t('Buste trop large'),
          id: "".concat(pricingVersion, ".mari-ret-cin-5")
        }]
      }, {
        slug: 'tooSmall',
        label: t('Elle est trop petite'),
        question: t('À quel endroit est-elle trop petite ?'),
        locations: [{
          slug: 'tooShort',
          label: t('Elle est trop courte'),
          id: "".concat(pricingVersion, ".mari-ret-ral-1")
        }, {
          slug: 'shortArm',
          label: t('Manches trop courtes'),
          id: "".concat(pricingVersion, ".mari-ret-ral-4")
        }, {
          slug: 'armTooTight',
          label: t('Manches trop serrées'),
          id: "".concat(pricingVersion, ".mari-ret-ela-3")
        }, {
          slug: 'tooSmallSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".mari-ret-ral-6")
        }, {
          slug: 'smallShoulder',
          label: t('Épaules trop étroite'),
          id: "".concat(pricingVersion, ".mari-ret-ela-2")
        }, {
          slug: 'smallChest',
          label: t('Buste trop étroit'),
          id: "".concat(pricingVersion, ".mari-ret-ela-5")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mari-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mari-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".mari-rep-tear-1"),
          multiple: true
        }]
      }, {
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".mari-ret-rac-1")
        }]
      }, {
        slug: 'talkRDV',
        label: t('En parler en RDV')
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mari-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mari-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".mari-rep-tear-1"),
          multiple: true
        }, {
          slug: 'unraveledHem',
          label: t('L‘ourlet est décousu'),
          id: "".concat(pricingVersion, ".mari-rep-div-3")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Accessoire'),
    slug: 'acce',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Il faut changer l’élastique'),
          id: "".concat(pricingVersion, ".acce-ret-div-6"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".acce-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".acce-rep-tear-1"),
          multiple: true
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".acce-rep-but-2"),
          multiple: true
        }]
      }, {
        slug: 'adjustment_acce_multiple',
        label: t('Besoin d’ajustement'),
        id: "".concat(pricingVersion, ".acce-rep-div-3"),
        multiple: true
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Il faut changer l’élastique'),
          id: "".concat(pricingVersion, ".acce-ret-div-6"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".acce-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".acce-rep-tear-1"),
          multiple: true
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".acce-rep-but-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }, {
    name: t('Petit accessoire'),
    slug: 'little_acce',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".acce-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Rideau'),
    slug: 'ride',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }, {
    name: t('Drap/Housse de couette'),
    slug: 'sheet',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Plaid & couvre lit'),
    slug: 'plaid',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }, {
    name: t('Housse de coussin'),
    slug: 'cous',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }, {
    name: t('Nappes'),
    slug: 'tableClothes',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Serviettes'),
    slug: 'napkins',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }]
  }, {
    name: t('Housse de canapé'),
    slug: 'sofa',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }, {
    name: t('Housse de chaise'),
    slug: 'chair',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }, {
      label: t('Upcycler'),
      subLabel: t('Transformer l’aspect initial'),
      slug: 'transformation'
    }, {
      label: t('Créer'),
      subLabel: t('Récupérer pour créer'),
      slug: 'creation'
    }]
  }];
};
var getOtherHomeItemIds = exports.getOtherHomeItemIds = function getOtherHomeItemIds() {
  var pricingVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPricingVersion();
  return ["".concat(pricingVersion, ".pull-rep-div-6")];
};
var _default = exports["default"] = getTree;